import {EventEmitter, Injectable, Output} from '@angular/core';
import {config} from '../services.config'
import {NetworkResponse} from "./index";
@Injectable({
  providedIn: 'root'
})
export class NetworkService {

  constructor() {
    if (document.hidden) {
      clearTimeout(this.ticker);
    }else{
      this.resetChecking();
    }
  }

  urls: string[] = [`${config.rpcUrl}/health`];
  checkInterval: number = 25000;
  active: boolean = true;
  ticker: any;
  response: {frontend:string, backend:string} | undefined;
  @Output() connection = new EventEmitter<NetworkResponse>();

  @Output() version = new EventEmitter<NetworkResponse>();


  checkConnection(url_index: number = 0) {
    const that = this;
    url_index = url_index || 0;

    let url = this.urls[url_index] || window.location.href;
    url = that.getUrlReadyToUse(url);

    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);

    xhr.onload = function() {
      that.response = JSON.parse(xhr.response);
      that.version.emit({status:true, version: that.response})
      that.handleCheckResult(true);
    };

    xhr.onerror = function () {
      //if there's more urls to check, check next one now.
      if (that.urls.length - 1 > url_index) {
        that.checkConnection(url_index + 1);
        return;
      }

      // There was a connection error of some sort, and we've checked all urls available.
      that.handleCheckResult(false);
    };

    xhr.send();
  }


  handleCheckResult(result: boolean) {
    if (!result && this.active) {
      this.dropped();
    } else if (result && !this.active) {
      this.restored();
    }
    this.active = result;
    this.resetChecking();
  }

  resetChecking() {
    const that = this;
    clearTimeout(this.ticker);
    this.ticker = setTimeout(function () {
      that.checkConnection();
    }, this.checkInterval);
  }

  getUrlReadyToUse(url:string) {
    let sQueryString: any, sQsChar, sNewUrl;
    // @ts-ignore
    sQueryString = /^[^#?]*(\?[^#]+|)/.exec(url)[1];

    sQsChar = (sQueryString) ? '&' : '?';
    sNewUrl = url; //+ sQsChar + '_=' + Math.round(Math.random() * 100000000);

    //make the url protocol-less
    sNewUrl = sNewUrl.replace(/^https?:/, '');

    //add slashes if they are not present
    if (!sNewUrl.match(/^\/\//)) {
      sNewUrl = '//' + sNewUrl;
    }

    return sNewUrl;
  }

  dropped() {
    this.connection.emit({status: false, version: this.response})
  }

  restored() {
    this.connection.emit({status: true, version: this.response})
  }

  getStatus() {
    return {
      conActive: this.active,
      checkUrls: this.urls,
      checkInterval: this.checkInterval
    }
  }

}
